import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const useGanttColumns = () => {
	const { t } = useTranslation();
	// Get custom captions from user session
	const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me")) || {};

	const columns = useMemo(() => [
		{
			id: "text",
			header: customCaptions?.serviceWorkOrder || "Work Order",
			width: 250,
		},
		{
			id: "interval",
			header: customCaptions?.interval || "Interval",
			flexGrow: 1,
		},
		{
			id: "status",
			header: t("label.status"),
			width: 100
		},
		{
			id: "percComplete",
			header: t("label.percentComplete"),
			width: 80
		},
		{
			id: "start",
			header: t("label.startDate"),
			width: 80,
		},
		{
			id: "estimatedMinutes",
			header: t("label.estHours"),
			width: 70
		},
	], [customCaptions, t]);

	return columns;
};

export default useGanttColumns;
